import React, { useState, useEffect } from 'react';
import BackNextButtons from './BackNextButtons';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { KeyboardDatePicker } from "@material-ui/pickers";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import AutoCompleteAddress from '../includes/AutoCompleteAddress';
import FormHelperText from '@material-ui/core/FormHelperText';
import DoneOutlinedIcon from '@material-ui/icons/DoneOutlined';
import { green } from '@material-ui/core/colors';
import CircularProgress from '@material-ui/core/CircularProgress';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { CalendarIcon, RoundedSquareIcon  } from '../includes/Icons';
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  selectRoot: {
    width: "100%", // Adjust this as needed
  },
  menu: {
    marginTop: "5px", // Ensures the dropdown starts just below the field
  },
}));

const CustomerDetails = (props) => {
    const classes = useStyles();
    const [state, setState] = useState({
        email: props.values.email,
        dateOfBirth: props.values.dob,
        authorisedDateOfBirth: props.values.authorisedDateOfBirth,
        joinDate: props.values.joinDate,
        startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
        endDate: new Date(new Date().setDate(new Date().getDate() + 30)),
        EighteenYear: new Date(new Date().setYear(new Date().getFullYear() - 18)),
        today: new Date(),
        nzdlStatus: props.values.nzdlStatus || false, // Default to false if undefined
        validationStatus: props.values.validationLoadingStatus,
    });

    useEffect(() => {
        const dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'sign_up_step',
            'screenDescription': 'enterYourDetails'
        });

        ValidatorForm.addValidationRule('isEmailMatch', (value) => {
            return value === props.values.email;
        });

        if (props.values.broadbandArray.length !== 0 && !props.values.broadbandArray.includes('phone')) {
            const defaultPlan = props.values.phonePlans.find(item => item.title === 'Local') || {};
            props.resetPhonePlan(defaultPlan);
        }

        return () => {
            ValidatorForm.removeValidationRule('isEmailMatch');
        };
    }, []);

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            email: props.values.email,
            validationStatus: props.values.validationLoadingStatus,
            nzdlStatus: props.values.nzdlStatus || false, // Default to false if undefined
        }));
    }, [props.values]);

    const getBirthDateChange = (dateFromChild) => {
        setState({ ...state, dateOfBirth: dateFromChild });
        props.getDOB(dateFromChild);
    };

    const handleAuthorisedDateOfBirth = (dateFromChild) => {
        setState({ ...state, authorisedDateOfBirth: dateFromChild });
        props.getAuthorisedDateOfBirth(dateFromChild);
    };

    const getJoinDateChange = (dateFromChild) => {
        setState({ ...state, joinDate: dateFromChild });
        props.getJoinDateChange(dateFromChild);
    };

    const setAddresses = (addressFromChild, type) => {
        props.setAddresses(addressFromChild, type);
    };

    const contributionDropDown = () => {
        const { pifContributionList } = props.values;
        if (!Array.isArray(pifContributionList)) {
            return null;
        }
        return pifContributionList.map((item) => (
            <MenuItem value={item} key={item}>${item}</MenuItem>
        ));
    };

    const submitForm = (e) => {
        e.preventDefault();

        console.log('jed1');
        if (state.dateOfBirth instanceof Date && isFinite(state.dateOfBirth)) {

            console.log('jed2');
            if (!props.values.postalAddress) {

                console.log('jed3');
                props.alertSearchMessage("Oops something went wrong", "Please enter your postal address");
            } else {

                console.log('jed4');
                props.submitForm();
            }
        } else {

            console.log('jed5');
            props.alertSearchMessage("Invalid Date", "Please enter your date of birth");
        }
    };

    const displayLicenceImage = () => {
        return confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui react-confirm-alert-body' id="successCallbackAlert">
                        <img src="https://signup.pulseenergy.co.nz/assets/pulse-energy/nz_dl_2.jpeg" alt="New Zealand Driver licence example" />
                        <button onClick={onClose}><CloseOutlinedIcon /></button>
                    </div>
                );
            },
            closeOnEscape: false,
            closeOnClickOutside: false,
        });
    };

    const { email, dateOfBirth, EighteenYear, authorisedDateOfBirth, validationStatus } = state;
    const dateToday = new Date();

    return (
        <React.Fragment>
            <div className="page-title-wrapper page-title-wrapper__customer-details">
                <h2 className="h2 primary" component="legend">{props.forms.EnterYourDetailsTitle}</h2>
                <p className="sublegend">{props.forms.EnterYourDetailsSubTitle}</p>
            </div>
            <ValidatorForm onSubmit={submitForm} method="POST" className="OnlineSignUp_CustomerDetails" encType="multipart/form-data">
                {/* Start About You */}
                <Accordion defaultExpanded>
                    <AccordionSummary className="accordion-legend" expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <FormLabel component="legend">About You</FormLabel>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div>
                            <div className="row">
                                <div className="col-md-12 col-lg-6 validatorNoPaddingDiv field-item field-first-item">
                                    <label htmlFor="firstName" style={{ display: 'block', marginBottom: '4px' }} 
                                        className="field-item__label">First Name*</label>
                                    <TextValidator 
                                        required
                                        withRequiredValidator={true}
                                        name="firstName" 
                                        variant="outlined"
                                        validators={['required', 'matchRegexp:[^ ]']}
                                        errorMessages={['Please enter your first name', 'Please enter your first name']}
                                        value={props.values.firstName} 
                                        onChange={props.handleChange('firstName')}
                                        className="field-item__input"
                                    />
                                </div>
                                <div className="col-md-12 col-lg-6 validatorNoPaddingDiv field-item">
                                    <label htmlFor="firstName" style={{ display: 'block', marginBottom: '4px' }}
                                        className="field-item__label">Last Name*</label>
                                    <TextValidator 
                                        required
                                        withRequiredValidator={true}
                                        validators={['required', 'matchRegexp:[^ ]']}
                                        errorMessages={['Please enter your last name', 'Please enter your last name']}
                                        name="lastName" 
                                        variant="outlined" 
                                        value={props.values.lastName} 
                                        onChange={props.handleChange('lastName')}
                                        className="field-item__input"
                                    />
                                </div>
                            </div>
                            <div className="row row-mobile-legend" style={{ marginTop: "10px" }}>
                                <div className="col-md-12 col-lg-6 validatorNoPaddingDiv field-first-item">
                                    <KeyboardDatePicker
                                        className="dateofbirthlabel"
                                        id="datePicker"
                                        required
                                        allowKeyboardControl
                                        disableFuture
                                        openTo="year"
                                        format="dd/MM/yyyy"
                                        InputLabelProps={{ shrink: true }}
                                        placeholder="DD/MM/YYYY"
                                        minDate="01/01/1900"
                                        value={dateOfBirth.toLocaleDateString() === dateToday.toLocaleDateString() ? null : dateOfBirth}
                                        error={dateOfBirth >= EighteenYear} 
                                        helpertext={dateOfBirth >= EighteenYear && "You must be 18 years of age to set up an Account with us."}
                                        label="Date Of Birth"
                                        onChange={date => getBirthDateChange(date)}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        keyboardIcon={<CalendarIcon />}
                                        variant="dialog"
                                    />
                                    <p className="first-legend">You must be 18 years of age to set up an account with us.</p>
                                </div>
                                {/* <div className="col-md-12 col-lg-6 validatorNoPaddingDiv field-item">
                                    <label htmlFor="gpe_membership" style={{ display: 'block', marginBottom: '4px' }}
                                        className="field-item__label">Grey Power Membership Number</label>
                                    <TextValidator 
                                        required
                                        withRequiredValidator={false}
                                        name="gpe_membership" 
                                        variant="outlined" 
                                        value={props.values.gpe_membership} 
                                        onChange={props.handleChange('gpe_membership')}
                                        className="field-item__input"
                                    />
                                </div> */}
                            </div>
                            <FormLabel component="legend" className='sub-heading'>
                                <h2 className="field-first-title-item">Contact Details</h2>
                            </FormLabel>
                            <div className="row">
                                <div className="col-md-12 col-lg-6 validatorNoPaddingDiv field-item field-first-item">
                                    <label htmlFor="mobilePhone" style={{ display: 'block', marginBottom: '4px' }}
                                        className="field-item__label">Mobile Phone*</label>
                                    <TextValidator 
                                        required
                                        type="number"
                                        name="mobilePhone" 
                                        validators={['required', 'matchRegexp:[^ ]']}
                                        errorMessages={['Please enter your mobile phone', 'Please enter your mobile phone']}
                                        variant="outlined" 
                                        value={props.values.mobilePhone} 
                                        onChange={props.handleChange('mobilePhone')}
                                        className="field-item__input"
                                    />
                                </div>
                                <div className="col-md-12 col-lg-6 validatorNoPaddingDiv field-item">
                                    <label htmlFor="emailAddress" style={{ display: 'block', marginBottom: '4px' }}
                                        className="field-item__label">Email Address*</label>
                                    <TextValidator
                                        required
                                        autoComplete='off'
                                        name="email" 
                                        variant="outlined" 
                                        value={email.replace(/ /g, '').toLowerCase()} 
                                        onChange={props.handleChange('email')}
                                        validators={['required', 'isEmail']}
                                        errorMessages={['This field is required', 'Email is not valid']}
                                        className="field-item__input"
                                    />
                                    <p className="secondary-legend">Your bill will be emailed to this address each month</p>
                                </div>
                            </div>
                            <FormLabel component="legend" className='sub-heading'>
                                <h2 className="field-first-title-item">Postal Addresss</h2>
                            </FormLabel>
                            {props.values.sameAddress ? (
                                <div className="field-first-postal-item">
                                    <FormControlLabel
                                        control={<Checkbox 
                                            checked={props.values.sameAddress} 
                                            onChange={props.handleChange('sameAddress')} 
                                            name="sameAddress" 
                                            icon={<RadioButtonUncheckedIcon />}
                                            checkedIcon={<RoundedSquareIcon />}
                                        />}
                                        label="Postal address is the same as your installation address"
                                    />
                                    <TextValidator 
                                        style={{ marginTop: "0" }}
                                        required
                                        name="postalAddress" 
                                        variant="outlined"  
                                        validators={['required', 'matchRegexp:[^ ]']}
                                        errorMessages={['This field is required', 'Please enter your postal address']}
                                        value={props.values.postalAddress}
                                        helpertext="This is where important communication will be delivered to11" 
                                        onChange={props.handleChange('postalAddress')}
                                        disabled={true}
                                        className="field-item__input"
                                    /> 
                                </div>
                            ) : (
                                <div className="field-first-postal-item">
                                    <AutoCompleteAddress
                                        values={props.values} 
                                        type="postal"
                                        setAddresses={setAddresses}
                                        handleChange={props.handleChange}
                                        label="Enter Postal Address"
                                    />
                                </div>
                            )}
                            <FormLabel component="legend" className='sub-heading mt-5'>
                                <h2 className="field-first-title-item">Identification</h2>
                            </FormLabel>
                            <div className="row identification-row-bottom-label">
                                <div className="col-md-12 col-lg-4 validatorNoPaddingDiv field-first-item">
                                    <FormControl variant="outlined" component="fieldset" className="identification-select-wrapper">
                                    <Select
                                        variant="outlined"
                                        className="identificationType field-item__input-select"
                                        required
                                        error={!props.values.identificationType}
                                        helpertext={
                                            !props.values.identificationType
                                            ? "Please select an identification type to proceed"
                                            : ""
                                        }
                                        labelId="identificationType"
                                        id="identificationType"
                                        value={props.values.identificationType}
                                        onChange={props.handleChange("identificationType")}
                                        IconComponent={ExpandMoreIcon}
                                        classes={{
                                            root: classes.selectRoot,
                                        }}
                                        MenuProps={{
                                            classes: { paper: classes.menu }, // Apply custom styles to the dropdown
                                            anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left",
                                            },
                                            transformOrigin: {
                                            vertical: "top",
                                            horizontal: "left",
                                            },
                                            getContentAnchorEl: null, // Ensures the dropdown aligns with the field
                                            disablePortal: true, // Prevents the dropdown from being rendered at the body level
                                        }}
                                        >
                                            <MenuItem value="Driver Licence">Driver Licence</MenuItem>
                                            <MenuItem value="Passport">Passport</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                {props.values.identificationType === 'Driver Licence' ? (
                                    <div className="col-md-12 col-lg-8 validatorNoPaddingDiv drivers-fieldset-wrapper field-first-item">
                                        <FormControl component="fieldset" className="drivers-fieldset">
                                            <TextValidator 
                                                required
                                                style={{ marginTop: "0" }} 
                                                name="licence5a" 
                                                label="Drive Licence 5a" 
                                                variant="outlined" 
                                                margin="normal"  
                                                value={props.values.licence5a.toUpperCase()} 
                                                onChange={props.handleChange('licence5a')}
                                                validators={['required', 'matchRegexp:[^ ]']}
                                                errorMessages={['This field is required', 'Please enter your licence 5a']}
                                                inputProps={{ minLength: 8, maxLength: 16 }}
                                                className="field-item__input"
                                            />
                                            <TextValidator 
                                                required
                                                validators={['required', 'matchRegexp:[^ ]']}
                                                errorMessages={['Please enter your licence 5b', 'Please enter your licence 5b']}
                                                type="text"
                                                style={{ marginTop: "0", marginBottom: "1rem" }} 
                                                name="licence5b" 
                                                label="Card version 5b" 
                                                variant="outlined" 
                                                margin="normal"  
                                                value={props.values.licence5b.toUpperCase()} 
                                                onChange={props.handleChange('licence5b')}
                                                className="field-item__input"
                                            />
                                            {validationStatus && (
                                                <div className="col-md-12 col-lg-1 d-flex flex-column justify-content-center align-content-center">
                                                    <CircularProgress fontSize="small" style={{ color: green[500] }} /> 
                                                </div>
                                            )}
                                            {state.nzdlStatus && !validationStatus && ( // Use state.nzdlStatus
                                                <div className="col-md-12 col-lg-1 d-flex flex-column justify-content-center align-content-center">
                                                    <DoneOutlinedIcon fontSize="large" style={{ color: green[500] }} />    
                                                </div>
                                            )}
                                        </FormControl>
                                    </div>
                                ) : (
                                    <div className="col-md-12 col-lg-8 validatorNoPaddingDiv field-item drivers-fieldset field-first-item">
                                        <FormControl component="fieldset" id="passportField">
                                            <TextValidator  
                                                required
                                                validators={['required', 'matchRegexp:[^ ]']}
                                                errorMessages={['Please enter your Passport Number', 'Please enter your Passport Number']}
                                                style={{ marginTop: "0" }} 
                                                name="passportNo" 
                                                label="Passport Number" 
                                                variant="outlined" 
                                                margin="normal"  
                                                value={props.values.passportNo.toUpperCase()} 
                                                onChange={props.handleChange('passportNo')}
                                                className="field-item__input"
                                            />
                                        </FormControl>
                                    </div>
                                )}
                            </div>

                            <FormLabel component="legend" className='sub-heading mt-5'>
                                <h2 className="field-first-title-item">Grey Power Membership Number</h2>
                            </FormLabel>
                            <div className="row">
                                <div className="col-md-12 col-lg-12 validatorNoPaddingDiv field-item field-first-item">
                                    <TextValidator 
                                        withRequiredValidator={false}
                                        name="gpe_membership" 
                                        variant="outlined" 
                                        placeholder="Grey Power Membership Number"
                                        value={props.values.gpe_membership} 
                                        onChange={props.handleChange('gpe_membership')}
                                        className="field-item__input"
                                    />
                                    <p className="secondary-legend">
                                        If your number is only 5 digits long, please add a 0 to the beginning.<br/>
                                        If you do not know your membership number please leave blank.
                                    </p>
                                </div>
                            </div>

                            {/* <div className="row identification-row-label"> disable
                                <FormHelperText className={!state.nzdlStatus && "Mui-error"} style={{ marginLeft: "1.5rem" }}>
                                    Please ensure your first and last name are entered as displayed on your driver licence.
                                </FormHelperText>
                            </div> */}
                            <div style={{ marginTop: "3rem" }}>
                                <FormLabel component="legend" className="authorised-subtitle">Authorised Contact Details</FormLabel>
                                <FormControlLabel
                                    className="authorised-wrapper"
                                    control={<Checkbox 
                                        checked={props.values.nominateAuthorisedPerson} 
                                        onChange={props.handleChange('nominateAuthorisedPerson')} 
                                        name="nominateAuthorisedPerson"
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RoundedSquareIcon />}
                                    />}
                                    label="I would like to nominate an alternative contact person"
                                />
                            </div>
                            {props.values.nominateAuthorisedPerson && (
                                <React.Fragment>
                                    <div className="row authorised-row">
                                        <div className="col-md-12 col-lg-6 validatorNoPaddingDiv field-item">
                                            <label htmlFor="Authorised First Name" style={{ display: 'block', marginBottom: '4px' }}
                                                className="field-item__label">First Name*</label>
                                            <TextValidator
                                                required
                                                validators={['required', 'matchRegexp:[^ ]']}
                                                errorMessages={['Please enter your Authorised Contact First Name', 'Please enter your Authorised Contact First Name']}
                                                withRequiredValidator={true}
                                                name="Authorised First Name" 
                                                placeholder="Enter First Name" 
                                                variant="outlined"  
                                                value={props.values.authorisedFirstName} 
                                                onChange={props.handleChange('authorisedFirstName')}
                                                className="field-item__input"
                                            />
                                        </div> 
                                        <div className="col-md-12 col-lg-6 validatorNoPaddingDiv field-item">
                                            <label htmlFor="Authorised Last Name" style={{ display: 'block', marginBottom: '4px' }}
                                                className="field-item__label">Last Name*</label>
                                            <TextValidator 
                                                required
                                                validators={['required', 'matchRegexp:[^ ]']}
                                                errorMessages={['Please enter your Authorised Contact Last Name', 'Please enter your Authorised Contact Last Name']}
                                                withRequiredValidator={true}
                                                name="Authorised Last Name" 
                                                placeholder="Enter Last Name" 
                                                variant="outlined" 
                                                value={props.values.authorisedLastName} 
                                                onChange={props.handleChange('authorisedLastName')}
                                                className="field-item__input"
                                            />
                                        </div> 
                                        <div className="col-md-12 col-lg-6 validatorNoPaddingDiv field-item mt-5">
              
                                            <KeyboardDatePicker
                                                className="dateofbirthlabel"
                                                id="datePicker"
                                                required
                                                allowKeyboardControl
                                                disableFuture
                                                openTo="year"
                                                format="dd/MM/yyyy"
                                                InputLabelProps={{ shrink: true }}
                                                placeholder="DD/MM/YYYY"
                                                minDate="01/01/1900"
                                                defaultValue={null}
                                                error={authorisedDateOfBirth >= EighteenYear} 
                                                helpertext={authorisedDateOfBirth >= EighteenYear ? "You must be 18 years of age to set up an Account with us." : ''}
                                                value={authorisedDateOfBirth}
                                                label="Date Of Birth"
                                                onChange={date => handleAuthorisedDateOfBirth(date)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                keyboardIcon={<CalendarIcon />}
                                                variant="dialog"
                                            />
                                        </div>
                                        <div className="col-md-12 col-lg-6 validatorNoPaddingDiv field-item mt-5">
                                            <label htmlFor="Authorised Contact Name" style={{ display: 'block', marginBottom: '4px' }}
                                                className="field-item__label">Contact Number*</label>
                                            <TextValidator 
                                                required
                                                validators={['required', 'matchRegexp:[^ ]']}
                                                errorMessages={['Please enter your Authorised Contact Number', 'Please enter your Authorised Contact Number']}
                                                withRequiredValidator={true}
                                                name="Authorised Contact Number" 
                                                placeholder="Enter Contact Number" 
                                                type="text"
                                                variant="outlined" 
                                                value={props.values.authorisedContactNumber} 
                                                onChange={props.handleChange('authorisedContactNumber')}
                                                className="field-item__input"
                                            />
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </AccordionDetails>
                </Accordion>

                {/* Start Billing Delivery */}
                
                <Accordion>
                    <AccordionSummary className="accordion-legend" expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <FormLabel component="legend">Billing Delivery</FormLabel>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div>
                            <label htmlFor="Authorised Last Name" style={{ display: 'block', marginBottom: '4px' }}
                                className="field-item__label">How would you like to receive your bill?</label>
                            <RadioGroup row aria-label="billingMethod" 
                                name="Billing Method" 
                                value={props.values.billingMethod} 
                                onChange={props.handleChange('billingMethod')} 
                                defaultValue={props.values.billingMethod}
                            >
                                <FormControlLabel value="online" control={<Radio color="primary" />} label="Online Bill" />
                                <FormControlLabel value="post" control={<Radio color="primary" />} label="Post (additional charges may apply)" />
                            </RadioGroup>
                        </div>
                    </AccordionDetails>
                </Accordion>

                {/* Start Modem Delivery Address */}

                {(props.values.broadbandArray.length && props.values.connectionOption !== 'BYO Modem') > 0 && (
                    <Accordion>
                        <AccordionSummary className="accordion-legend" expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                            <FormLabel component="legend">Modem Delivery Address</FormLabel>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div>
                                {/* Temp Data */}
                                {/* {props.values.broadbandArray.length > 0 && ( */}
                                {/* <AutoCompletePlaces 
                                    values={props.values} 
                                    type="modem"
                                    setAddresses={setAddresses}
                                /> */}
                                {/* )} */}
                                {props.values.sameModemAddress ? (
                                    <React.Fragment>
                                        <FormControlLabel
                                            control={<Checkbox 
                                                checked={props.values.sameModemAddress} 
                                                onChange={props.handleChange('sameModemAddress')} 
                                                name="sameModemAddress"
                                                icon={<RadioButtonUncheckedIcon />}
                                                checkedIcon={<RoundedSquareIcon />}
                                            />}
                                            label="Modem delivery address is the same as your installation address."
                                        />
                                        <TextValidator 
                                            style={{ marginTop: "0" }}
                                            required
                                            name="modemDeliveryAddress" 
                                            label="Enter delivery address if different from above"
                                            variant="outlined"  
                                            validators={['required', 'matchRegexp:[^ ]']}
                                            errorMessages={['This field is required', 'Please enter your postal address']}
                                            value={props.values.modemDeliveryAddress}
                                            helpertext="This is where important communication will be delivered to11" 
                                            onChange={props.handleChange('modemDeliveryAddress')}
                                            disabled={true}
                                            className="field-item__input"
                                        /> 
                                    </React.Fragment>
                                ) : (
                                    <AutoCompleteAddress
                                        values={props.values} 
                                        type="modem"
                                        setAddresses={setAddresses}
                                        handleChange={props.handleChange}
                                        label="Enter Postal Address"
                                    />
                                )}

                            </div>
                        </AccordionDetails>
                    </Accordion>
                )}

                {/* Start Property Details */}
                <Accordion>
                    <AccordionSummary className="accordion-legend" expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <FormLabel component="legend">Property Details</FormLabel>
                    </AccordionSummary>
                    <AccordionDetails className="property-details-wrapper">
                        <div>
                            <label htmlFor="firstName" style={{ display: 'block', marginBottom: '4px' }}
                                className="field-item__label">What is your situation?</label>
                            <RadioGroup row aria-label="customerSituation" name="customerSituation" value={props.values.customerSituation} onChange={props.handleChange('customerSituation')} defaultValue={props.values.customerSituation}>
                                <FormControlLabel value="switch" control={<Radio color="primary" />} label="I want to switch providers" />
                                <FormControlLabel value="moving" control={<Radio color="primary" />} label="I am moving house/ I just moved house" />
                            </RadioGroup>
                            {props.values.customerSituation === 'moving' && (
                                <React.Fragment>
                                    <div className="row">
                                        <div className="col-md-12 col-lg-6 validatorNoPaddingDiv field-item">
                                            <label htmlFor="firstName" style={{ display: 'block', marginBottom: '4px' }}
                                                className="field-item__label">Date you would like to join*</label>
                                            <KeyboardDatePicker
                                                className="datejoinlabel dateofbirthlabel"
                                                style={{ marginBottom: "1rem" }}
                                                required
                                                margin="normal"
                                                id="date-picker-dialog"
                                                openTo="year"
                                                format="dd/MM/yyyy"
                                                placeholder="DD/MM/YYYY"
                                                maxDateMessage="Please try again. Date cannot exceed one month in advance"
                                                minDateMessage="Please try again. Date cannot exceed one month before"
                                                value={props.values.joinDate}
                                                allowKeyboardControl={false}
                                                minDate={state.startDate}
                                                maxDate={state.endDate}
                                                onChange={date => getJoinDateChange(date)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                keyboardIcon={<CalendarIcon />}
                                                variant="dialog"
                                            />
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                            <label htmlFor="firstName" style={{ display: 'block', marginBottom: '4px', marginTop: '15px' }}
                                className="field-item__label">Is there a dog on the property?</label>
                            <RadioGroup row aria-label="haveDog" name="Have dog" value={props.values.haveDog} onChange={props.handleChange('haveDog')} defaultValue={props.values.haveDog}>
                                <FormControlLabel value="yes" control={<Radio color="primary" />} label="Yes" />
                                <FormControlLabel value="no" control={<Radio color="primary" />} label="No" />
                            </RadioGroup>
                            <label htmlFor="firstName" style={{ display: 'block', marginBottom: '4px', marginTop: '15px' }}
                                className="field-item__label">Is anyone at the property medically dependent?</label>
                            <RadioGroup row aria-label="medicallyDependent" label="Is anyone at the property medically dependent" name="medicallyDependent" value={props.values.medicallyDependent} onChange={props.handleChange('medicallyDependent')} defaultValue={props.values.medicallyDependent}>
                                <FormControlLabel value="yes" control={<Radio color="primary" />} label="Yes" />
                                <FormControlLabel value="no" control={<Radio color="primary" />} label="No" />
                            </RadioGroup>
                            <label htmlFor="firstName" style={{ display: 'block', marginBottom: '4px', marginTop: '15px' }}
                                className="field-item__label">Additional Property Notes</label>
                            <TextareaAutosize
                                id="additionalNotes"
                                minRows={4}
                                aria-label="Additional Property Notes"
                                placeholder="Enter Additional Property Notes: Property has locked gate / House is down a long driveway etc."
                                onChange={props.handleChange('additionalNotes')}
                            />
                        </div>
                    </AccordionDetails>
                </Accordion>

                {/* Start Pay it Forward Programme */}
                <Accordion>
                    <AccordionSummary className="accordion-legend" expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <FormLabel component="legend">Pay it Forward Programme</FormLabel>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div>
                            {props.values.pifContributionList && (
                                <React.Fragment>
                                    <label htmlFor="firstName" style={{ display: 'block', marginBottom: '4px', marginTop: '15px' }}
                                        className="field-item__label">Our Pay it Forward Programme helps families experiencing energy hardship. Would you like to take part by adding a contribution to your monthly bill?</label>
                                    <RadioGroup row aria-label="payitforward" name="Pay It Forward" value={props.values.payitforward} onChange={props.handleChange('payitforward')} defaultValue={props.values.payitforward}>
                                        <FormControlLabel value="yes" control={<Radio color="primary" />} label="Yes" />
                                        <FormControlLabel value="no" control={<Radio color="primary" />} label="No" />
                                    </RadioGroup>
                                </React.Fragment>
                            )}
                            {props.values.payitforward === 'yes' && Array.isArray(props.values.pifContributionList) && ( 
                                <React.Fragment>
                                    <div className="d-flex mb-4" id="pif_amount_div">
                                        <FormControl component="fieldset">
                                            <label htmlFor="firstName" style={{ display: 'block', marginBottom: '4px', marginTop: '15px' }}
                                                className="field-item__label">Monthly contribution</label>
                                            <p className="footnotes__text__description pay-it-forward-programme-text">
                                                This will be added to your monthly bill. <a href="https://pulseenergy.co.nz/pay-it-forward-terms-and-conditions-1for1/" target="_blank" rel="noopener noreferrer" className="pay-it-forward-programme-link">For full terms click here</a>
                                            </p>
                                            <Select
                                                variant="outlined"
                                                 className="identificationType field-item__input-select"
                                                required
                                                error={!props.values.pif_amount}
                                                helpertext={!props.values.pif_amount ? "Please select one of the following" : ''}
                                                labelId="pif_amount"
                                                id="pif_amount"
                                                value={props.values.pif_amount}
                                                onChange={props.handleChange('pif_amount')}
                                                IconComponent={ExpandMoreIcon}
                                            >
                                                {contributionDropDown()}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </AccordionDetails>
                </Accordion>

                {/* Start Terms and Conditions */}
                <Accordion>
                    <AccordionSummary className="accordion-legend" expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <FormLabel component="legend">Terms & Conditions</FormLabel>
                    </AccordionSummary>
                    <AccordionDetails className="terms-conditions">
                        <div>
                            {/* <FormControlLabel
                                control={<Checkbox 
                                    required
                                    checked={props.values.creditCheckTermsAccepted} 
                                    onChange={props.handleChange('creditCheckTermsAccepted')} 
                                    name="checkedCreditCheckTerms" 
                                />}
                                label={<div dangerouslySetInnerHTML={{ __html: props.values.creditCheckTerms }}></div>}
                            /> */}
                            {/* {!props.values.creditCheckTermsAccepted && props.isSubmitted && <FormHelperText error className="MuiFormHelperText-root Mui-error">Please accept the credit check terms.</FormHelperText>} */}
                            <FormControlLabel
                                control={<Checkbox 
                                    required
                                    checked={props.values.termsAccepted}
                                    onChange={props.handleChange('termsAccepted')} 
                                    name="checkedPulseTerms" 
                                />}
                                label={<div dangerouslySetInnerHTML={{ __html: props.values.applicationTerms }}></div>}
                            />
                            {!props.values.termsAccepted && props.isSubmitted && <FormHelperText error className="MuiFormHelperText-root Mui-error">Please accept the terms and conditions.</FormHelperText>}
                            <div dangerouslySetInnerHTML={{ __html: props.values.creditCheckTerms }}></div>
                        </div>
                    </AccordionDetails>
                </Accordion>

                <BackNextButtons 
                    values={props.values}
                    toTop={props.toTop}
                    nextStep={props.nextStep}
                    prevStep={props.prevStep}
                    id="CustomerDetails"
                />
            </ValidatorForm>
        </React.Fragment>
    );
};

export default CustomerDetails;